import { DEFAULT_THEME } from '@mantine/core';
import { getIcon } from '../FreeSpaceIcons';
import countryTracks from './country.json';
import holidayTracks from './holiday.json';
import eightiesTracks from './80s.json';
import ninetiesTracks from './90s.json';
import halloweenTracks from './halloween.json';
import stpatricksTracks from './stpatricks.json';

const {
  yellow,
  orange,
  red,
  blue,
  cyan,
  pink,
  green,
} = DEFAULT_THEME.colors;

const games = [
  {
    id: '80',
    label: '\'80s',
    title: '🕺 Retro \'80s 😎',
    titleStyle: {
      fontFamily: 'Fugaz One',
      color: cyan[7],
    },
    freeSpace: {
      text: 'PARTY ON',
      color: pink[7],
      icon: getIcon('HiOutlineMusicalNote'),
      
    },
    tracks: eightiesTracks,
  },
  {
    id: '90',
    label: '\'90s',
    title: '\'90s Mixtape',
    titleStyle: {
      fontFamily: 'Permanent Marker',
      color: blue[9],
    },
    freeSpace: {
      text: 'COWABUNGA',
      color: blue[9],
      icon: getIcon('HiOutlineFire'),
    },
    tracks: ninetiesTracks,
  },
  {
    id: 'COUNTRY',
    label: 'Country night',
    title: '🐴 Songs for Cowboys 🤠',
    titleStyle: {
      fontFamily: 'Sancreek',
      color: yellow[9],
    },
    freeSpace: {
      text: 'HOWDY PARTNER',
      color: yellow[9],
      icon: getIcon('HorseshoeIcon'),
    },
    tracks: countryTracks,
  },
  {
    id: 'HOLIDAY',
    label: 'Holidays',
    title: '⛄️ Happy Festivus 🎄',
    titleStyle: {
      fontFamily: 'Berkshire Swash',
      color: red[9],
    },
    freeSpace: {
      text: 'LET IT SNOW',
      icon: getIcon('SnowflakeIcon'),
      color: green[9],
    },
    tracks: holidayTracks,
  },
  {
    id: 'STPATRICKS',
    label: 'St. Patrick\'s',
    title: '💋 Kiss Me, I\'m Irish 🇮🇪',
    titleStyle: {
      fontFamily: 'Bangers',
      color: green[9],
    },
    freeSpace: {
      text: 'SLÁINTE',
      color: green[9],
      icon: getIcon('ShamrockIcon'),
    },
    tracks: stpatricksTracks,
  },
  {
    id: 'HALLOWEEN',
    label: 'Halloween',
    title: '👻 Happy Halloween 🎃',
    titleStyle: {
      fontFamily: 'Creepster',
      color: orange[9],
    },
    freeSpace: {
      text: 'TRICK OR TREAT',
      color: orange[9],
      icon: getIcon('SkullIcon'),
    },
    tracks: halloweenTracks,
  },
];

export default games;